export default "__VITE_ASSET__B_Z9kYmK__"